export class Staff {

    public id: string = "0";
    public name: string;
    public title: string;
    public email: string;
    public cellPhone: string;
    public city: string;
    public state: string;
    public country: string;
    
    constructor() {}
}